var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessCircleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-circle-outline",
    transform: "translate(-3.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M17.5,3.5a14,14,0,0,1,5.449,26.9,14,14,0,0,1-10.9-25.8A13.905,13.905,0,0,1,17.5,3.5Zm0,26.526a12.53,12.53,0,1,0-8.856-3.67A12.444,12.444,0,0,0,17.5,30.026Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M18.031,10.966a.96.96,0,0,1,1.362-.014.972.972,0,0,1,.013,1.37l-5.128,6.444a.96.96,0,0,1-1.387.026l-3.4-3.417a.971.971,0,0,1,.415-1.653.96.96,0,0,1,.946.284l2.69,2.7,4.461-5.714a.3.3,0,0,1,.026-.028Z",
    transform: "translate(3.067 2.624)",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessCircleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success_circle_icon.7a7f6fab38e78bd6c15fc6388b146ff7.svg";